import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const BooleanFunctionSimplificationKMap = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Simplification of Boolean Functions | Gate-Level Minimization: K-map, SOP & POS"
    videos={[
      "https://www.youtube.com/embed/zKiTfSWl130",
      "https://www.youtube.com/embed/y-aYzGdlM-8",
      "https://www.youtube.com/embed/JRR8RCKMKjA",
      "https://www.youtube.com/embed/YmKmS9bpMqM",
      "https://www.youtube.com/embed/Z3wIPdCv_Oo",
      "https://www.youtube.com/embed/ZayoUTi2tsA"

    ]}
    takeaways={[
      { text: "Mostly KMaps is the most important topic for both CAT and FAT." },
      { text: "Learn simplification of Boolean function using Boolean laws, that can come for 5 or 7 mark question." }
    ]}
    questions={[
      "Use K maps to find the minimum-cost SOP and POS expressions for the function and draw the corresponding logic diagrams of SOP and POS expressions F(a,b,c,d)=a'c'd' + cd + a'b'd + abc'd",
      "Convert the following function to canonical SOP form and simplify using K Map F(A,B,C,D)= A'BC+ABC+B'C'+AC'D'",
      "Simplify the following function to standard POS form using K Map F(A,B,C,D)= A'BC+ABC+B'C'+AC'D'",
      "Simplify the following expression using Boolean Algebra (Reduce to three terms) F= a'bcd + a'bc'd + b'ef + cde'g + a'def + (a+b)'ef",
      "Simplify each of the following expressions using consensus theorem (or its dual) (i) F= w'x' + x'y' + yz + (w+z)' (ii) F= (A+B+E')(E+F+G')(A+B+F+G')",
      "Consider the Boolean Function F(w,x,y,z)= wy + xy + w'xyz + w'x'y + xz + x'y'z'. Simplify using K Map and identify the complete set of essential prime implicants",
      "Simplify the Boolean expression using theorems and postulates. Draw the logic diagram using logic gates for the simplified Boolean expression a) Y= A'B + B'C + C + A'B'C'D' + C'D' b) F(a,b,c,d) = ∑ m (0,1,3,8,9,13,15)",
      "Simplify the following Boolean expression using Boolean Algebra a) A'B(D'+C'D) + B(A+A'CD) (to one literal) b) BC'D' + ABC' + AC'D + AB'D + A'BD' (to three literals)",
      "Convert the given expression in SOP and POS canonical form F(A,B,C) = (A+B)(B+C)(A+C)",
      "Simplify the following using K-Map and draw the logic diagram using only NAND gates. F(a,b,c,d) = ac'd' + a'c + abc + ab'c + a'c'd'",
      "Using the Karnaugh map method obtain the minimal sum of the products and product of sums expressions for the function F(A,B,C,D) = ∑ (1,5,6,7,11,12,13,15)",
      "Find the prime implicants for the following Boolean functions, and determine which are essential: F(A,B,C,D)=∑m(1,3,4,5,9,10,11,12,13,14,15)",
      "Simplify the following Boolean expression to minimum no of literals using the laws of Boolean Algebra a) A= ((X+(YZ)')'(X'YZ)(X+Y))' b) Z= A'BC + AB'C' + A'B'C' + AB'C + ABC c) Y= (A'+B')(A+C') + B'(B+C)(A+B+C)' d) Y= (C+D)' + A'CD' + AB'C' + A'B'CD + ACD'",
      "Simplify the Boolean Function by Boolean Algebra F= AB + (AC)' + AB'C (AB+C)",
      "Obtain the canonical POS of the expression F=A+B'C"
    ]}
    exampleVideos={[]}
  />
);
}

export default BooleanFunctionSimplificationKMap;
